<!-- @format -->

@if (
  (responsibilityInfo?.personId || (responsibilityInfo?.text | localizedStringExistingLocales)?.length) &&
  (showInactiveResponsibilities || !responsibilityInfo?.validityPeriod || (responsibilityInfo.validityPeriod | dateRangeOngoing))
) {
  <div class="person">
    @if (responsibilityInfo?.personId | publicPerson | async; as person) {
      <span class="person__name">
        <span>{{ person | personFullName }}</span>
        @if (person.emailAddress?.length) {
          <span> ({{ person.emailAddress }})</span>
        }
      </span>
    }
    @if (responsibilityInfo?.text) {
      <span [ngClass]="{ 'person__by-text': !responsibilityInfo?.personId }"
        >{{ responsibilityInfo?.personId ? "," : "" }} {{ responsibilityInfo.text | localizedString }}</span
      >
    }
    @if (responsibilityInfo?.roleUrn | codeLocalizedName | async; as roleName) {
      <span>{{ ", " + roleName }}</span>
    }
    @if (
      showResponsibilityValidityPeriod &&
      responsibilityInfo?.validityPeriod &&
      (responsibilityInfo.validityPeriod.endDate || responsibilityInfo.validityPeriod.startDate)
    ) {
      <span class="dates"
        >,
        {{ responsibilityInfo.validityPeriod | localDateRange }}
      </span>
    }
  </div>
}
